import React from 'react';
import { Link } from 'react-router-dom';

// Top-right counterpart to BackButton. Rendered on every non-Home page
// except Stack, whose top-right corner holds its own floating controls.
const HomeButton = () => (
  <Link to="/" className="home-link" aria-label="Home">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5 9v11h14V9" />
    </svg>
  </Link>
);

export default HomeButton;
